interface ProgressRingProps {
  value: number;
  colorClass: string;
  size?: number;
  stroke?: number;
}

const ProgressRing = ({
  value,
  colorClass,
  size = 44,
  stroke = 4,
}: ProgressRingProps) => {
  const clamped = Math.min(100, Math.max(0, value));
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (clamped / 100) * circumference;

  return (
    <span
      className="relative inline-flex shrink-0 items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          className="text-gray-200 dark:text-gray-800"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={colorClass}
        />
      </svg>
      <span className="absolute text-[11px] font-semibold text-gray-700 dark:text-gray-200">
        {clamped}%
      </span>
    </span>
  );
};

export type { ProgressRingProps };
export default ProgressRing;
